<!DOCTYPE html>
<html>

<head>

    <title>Page Title</title>
    <style>
        p {
            margin: 0 0 1rem 0;
        }

        .text-content p {
            word-break: break-word;
        }

        .text-content {
            font-size: 20px;
            line-height: 2;
            font-weight: 400;
            color: #474747;
        }

        .popup-enabler {
            margin-top: 5px;
            padding: 0 2.76rem 1rem 4.13rem;
        }

        .text-content table {
            font-size: 1rem;
        }

        #optanon-cookie-policy-wrapper .cookie-policy-table {
            overflow-x: auto;
        }
        .cookie-table{
            width: 100%;
            border-collapse:collapse;
            font-size: 12px;
        }
        .cookie-table th,.cookie-table td{
            border:1px solid #000;
            padding:8px;
            text-align:left;

        }
        .cookie-table th{
            background-color:#fff;
        }
        .text-content h1,
        .text-content h2,
        .text-content h3,
        .text-content h4,
        .text-content h5,
        .text-content h6 {
            color: #474747;
        }

        h2 {
            font-size: 2.25rem;
            line-height: 1.22;
            font-weight: 300;
            color: #474747;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin: 0 0 0.45em 0;
        }

        body,
        ul,
        ol,
        li,
        dl,
        dt,
        dd,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        hgroup,
        p,
        blockquote,
        figure,
        form,
        fieldset,
        input,
        legend,
        pre,
        abbr {
            margin: 0;
            padding: 0;
        }

        .section-content {
            margin-left: auto;
            margin-right: auto;
            width: 80%;
            margin-top: 1.625rem;
            min-width: 940px;
        }

        .section {
            position: relative;
            width: 100%;
            background-color: #fff;
        }

        article,
        aside,
        footer,
        header,
        nav,
        main,
        section,
        summary,
        details,
        hgroup,
        figure,
        figcaption {
            display: block;
        }

        @media only screen and (min-width: 1280px) {
            .section-content {
                width: 1140px;
            }
        }
    </style>
</head>

<body>

    <section class="section section-content section-enter section-leave" data-global-theme="theme-black" id="section_1" style="overflow: scroll;height:100%">
        <div class="text-content abstract-text-content popup-enabler" >
            <h2>Cookie Policy</h2>
            <p>Tata Consultancy Services Limited uses cookies (small text files placed on your device) and similar
                technologies to provide our websites and to help collect data. The text in a cookie often consists of a
                string of numbers and letters that uniquely identifies your computer, but it can contain other
                information
                as well.</p>
            <p><strong>Our Use of Cookies and Similar Technologies.</strong></p>
            <p>Tata Consultancy Services uses cookies and similar technologies for several purposes, which may include:
            </p>
            <ul>
                <li>
                    <p><em>Storing your Preferences and Settings</em>. Settings that enable our website to operate
                        correctly
                        or that maintain your preferences over time may be stored on your device.</p>
                </li>
                <li>
                    <p><em>Sign-in and Authentication</em>. When you sign into our website using your credentials, we
                        store
                        a unique ID number, and the time you signed in, in an encrypted cookie on your device. This
                        cookie
                        allows you to move from page to page within the site without having to sign in again on each
                        page.
                        You can also save your sign-in information so you do not have to sign in each time you return to
                        the
                        site.</p>
                </li>
                <li>
                    <p><em>Security.</em> Tata Consultancy Services sets cookies when you visit our websites. Tata
                        Consultancy Services sets cookies that are technical and necessary for the function of the
                        website, for example, that allow you to browse the website and use the different options
                        included in this for the management of the website and enable its functions and services, such
                        as controlling data traffic and communication, identifying the session, using safety elements
                        during browsing.</p>
                </li>
            </ul>
            <p> Some of the cookies we commonly use are listed below. This list is not exhaustive, but it is intended to
                illustrate the main reasons we typically set cookies. If you visit one of our websites, the site may set
                some or all of the following cookies:</p>
            <div id="optanon-cookie-policy-wrapper">
                <p>A cookie is a small piece of data (text file) that a website – when visited by a user – asks your
                    browser
                    to store on your device in order to remember information about you, such as your language preference
                    or
                    login information. Those cookies are set by us and called first-party cookies. More specifically, we
                    use
                    cookies and other tracking technologies for the following purposes:</p>
                <div aria-label="Cookies Table" class="cookie-policy-table">
                    <table class="cookie-table" id="cookie-table" width="1000" border="1" cellpadding="4" cellspacing="0" style="border-color: black;border-style: solid;border-width: 1px;
                        font-size: 15px;">
                        <thead>
                            <tr>
                                <th width="23%" height="2" scope="col">
                                    <p><strong>Cookie Name</strong></p>
                                </th>
                                <th width="36%" scope="col">
                                    <p><strong>Description</strong></p>
                                </th>
                                <th width="15%" scope="col">
                                    <p><strong>Cookie Category</strong></p>
                                </th>
                                <th width="15%" scope="col">
                                    <p><strong>Domain</strong></p>
                                </th>
                                <th width="10%" scope="col">
                                    <p><strong>Expiry</strong></p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td width="82" height="35" title="Cookie Name">
                                    <p><strong>SSM_AU_C</strong></p>
                                </td>
                                <td width="213">
                                    <p>General purpose platform session cookie, used by sites written in JSP. Usually
                                        used
                                        to maintain an anonymous user session by the server.</p>
                                </td>
                                <td width="134">
                                    <p>First Party - Strictly Necessary</p>
                                </td>
                                <td width="134">
                                    <p>tcscognix.com</p>
                                </td>
                                <td width="63">
                                    <p>Session</p>
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div>
            </div>
            <p>&nbsp;</p>

            <p><strong>How to Control Cookies&nbsp;Manually</strong></p>
            <p>You can set your browser:</p>
            <p>• To allow all cookies</p>
            <p>• To allow only 'trusted' sites to send them</p>
            <p>• To accept only those cookies from websites you are currently using.</p>
            <p>We recommend not to block all cookies because TCS.com website uses them to work properly.</p>
            <p><strong>Please read below points to find out how to manage cookies in the major browsers.</strong></p>
            <p><em>Google Chrome</em>:</p>
            <p>Click on the “Menu” tab in the upper-right corner and then click on “Settings”.</p>
            <p>To block cookies:</p>
            <p>Settings → Click on “Advanced” to expand → Under Privacy and Security, Click on “Content Settings” →
                Click on
                “Cookies” → To block cookies, Click on toggle button next to this line “Allow sites to save and read
                cookie
                data (recommended)“ → This will block the cookies.</p>
            <p>To check cookies:</p>
            <p>Settings → Click on “Advanced” to expand → Under Privacy and Security → Click on “Content Settings” →
                Click
                on “Cookies” → See all cookies and site data → Click on the website and check the cookies used in that
                particular site.</p>
            <p>&nbsp;</p>

            <p><em>Internet Explorer</em>:</p>
            <p>Open Internet Explorer → Click on Tools menu in the upper-right corner → Click on Internet Options → This
                will open a window with many tab → Click on Privacy tab → Under Settings, move the slider to the top to
                block all cookies or to the bottom to allow all cookies → Then click Apply.</p>
            <p>Open Internet Explorer → Click on Tools menu in the upper-right corner → Click on Internet Options → This
                will open a window with many tabs → Click on Privacy tab → Click on Sites button → Enter site name and
                then
                click Allow or Block button → If user clicks block button, that website is not allowed to use cookies in
                IE
                → Then click Apply.</p>

            <p>To find information relating to other browsers, visit the browser developer's website.</p>
        </div>
    </section>

</body>

</html>